require('./bootstrap');
import * as bootstrap from 'bootstrap';

Main = {
    // Variables.
    baseUrl: window.location.origin,

    /**
     * Initialization.
     *
     */
    init: function () {
        this.ajaxSetup();
        this.validationConfig();
        this.addValidationRules();
        this.logout();
        this.sidebar();
        this.tooltip();
        this.preventModalScroll();

        console.log('Logs: Main script init.');
    },

    tooltip: function () {
        document.addEventListener('DOMContentLoaded', function () {
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl);
            });
        });
    },

    /**
     * Configure global ajax.
     *
     */
    ajaxSetup: function () {
        $.ajaxSetup({
            headers: {
                'Accept': 'application/json',
                'Authorization': Cookies.get('token') ? 'Bearer ' + Cookies.get('token') : '',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            statusCode: {
              401: function (xhr) {
                if (xhr.responseJSON && xhr.responseJSON.redirect) {
                  window.location.replace(xhr.responseJSON.redirect);
                  return;
                }
                // Session expired or unauthorized
                const currentUrl = window.location.href;
                // redirect to login with intended URL
                window.location.href = '/login?redirect=' + encodeURIComponent(currentUrl);
              },
              419: function () {
                // CSRF token expired or session timeout
                const currentUrl = window.location.href;
                window.location.href = '/login?redirect=' + encodeURIComponent(currentUrl);
              }
            }
        });
    },

    /**
     * Configure global jquery validation.
     *
     */
    validationConfig: function () {
        $.validator.setDefaults({
            errorElement: 'span',
            errorClass: 'is-invalid',
            errorPlacement: function(error, element) {
                if(element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }

                $('html, body').animate({
                    scrollTop: error.offset().top - 300
                }, 50);
            },
            invalidHandler: function(event, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    if ($(".is-invalid").length) {
                        $('html, body').animate({
                            scrollTop: ($(".is-invalid").first().offset().top - 300)
                        },50);
                    }
                }
            }
        });
    },

    /**
     * Create custom validation rules.
     *
     */
    addValidationRules: function () {
        $.validator.addMethod('phone', function(phone_number, element) {
            phone_number = phone_number.replace(/\s+/g, "");
            return this.optional(element) || phone_number.length > 9 &&
                phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
        }, "Please specify a valid phone number");
    },

    /**
     * Logout in system.
     *
     */
    logout: function (){
        const that = this;

        $(document).ready(function() {
            $(document).on('click', '.js-btn-logout', function (e){
                e.preventDefault();
                $.ajax({
                    type: 'DELETE',
                    url: that.baseUrl + '/api/v1/logout',
                    success:function(data) {
                        Cookies.remove('token');
                        Cookies.remove('users_role_token');
                        Cookies.remove('icdr_session');
                        window.location.replace('/');
                    },
                    error: function (error) {
                        console.error('Logout error:', error);
                    },
                });
            });
        });
    },

    /**
     * Sidebar menu.
     *
     */
    sidebar: function (){
        var that = this;
        $(document).ready(function() {
            const btnSidebarCollapse = $('.js-btn-sidebar-collapse');
            // that.toggleSidebar()
            btnSidebarCollapse.on('click', function () {
                $('#sidebar').toggleClass('active');
                // that.toggleSidebar()
            });
        });
    },

    /**
     * Prevent body scroll when modal is open (mobile fix).
     *
     */
    preventModalScroll: function (){
        $(document).ready(function() {
            // Store original body overflow style
            var originalBodyOverflow = '';
            var scrollPosition = 0;
            var touchMoveHandler = null;

            // Detect iOS Safari
            var isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            // Prevent touchmove on body for iOS Safari
            if (isIOSSafari) {
                touchMoveHandler = function(e) {
                    // Allow scrolling inside modal
                    var $target = $(e.target);
                    var isModalContent = $target.closest('.modal-content, .modal-body').length > 0;
                    if (!isModalContent) {
                        e.preventDefault();
                    }
                };
            }

            // Save scroll position BEFORE modal opens (before Bootstrap can scroll to top)
            $(document).on('show.bs.modal', '.modal', function() {
                scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                originalBodyOverflow = $('body').css('overflow');
            });

            // Prevent body scroll when modal is shown
            $(document).on('shown.bs.modal', '.modal', function() {
                // Apply styles to body and html for better compatibility
                /*if (scrollPosition > 0) {
                    $('body, html').css({
                        'position': 'fixed',
                        'top': '-' + scrollPosition + 'px',
                        'width': '100%',
                        'height': '100%'
                    });
                }*/
                
                // Add touchmove prevention for iOS Safari
                if (isIOSSafari && touchMoveHandler) {
                    document.body.addEventListener('touchmove', touchMoveHandler, { passive: false });
                    document.addEventListener('touchmove', touchMoveHandler, { passive: false });
                }
            });

            // Restore body scroll when modal is hidden
            $(document).on('hidden.bs.modal', '.modal', function() {
                // Remove touchmove prevention for iOS Safari
                if (isIOSSafari && touchMoveHandler) {
                    document.body.removeEventListener('touchmove', touchMoveHandler);
                    document.removeEventListener('touchmove', touchMoveHandler);
                }
                
                // Remove all inline styles completely
                /*$('body, html').each(function() {
                    // Remove specific styles using native JavaScript
                    this.style.removeProperty('position');
                    this.style.removeProperty('top');
                    this.style.removeProperty('width');
                    this.style.removeProperty('height');
                });*/
                
                // Remove modal-open class if exists (Bootstrap adds it)
                $('body').removeClass('modal-open');
                
                // Restore scroll position after a small delay to ensure styles are removed
                /*setTimeout(function() {
                    if (scrollPosition > 0) {
                        window.scrollTo(0, scrollPosition);
                    }
                }, 10);*/
            });
        });
    },
    toggleSidebar: function () {
        if($(window).width() < 1200){
            // if($('#sidebar').hasClass('active')) {
            //     $('.js-sidebar-action-header').hide();
            //     $('.js-sidebar-action-reverse-header').show();
            // } else {
            //     $('.js-sidebar-action-header').show();
            //     $('.js-sidebar-action-reverse-header').hide();
            // }
        } else {
            if($('#sidebar').hasClass('active')) {
                $('.js-sidebar-action-header').show();
                $('.js-sidebar-action-reverse-header').hide();
            } else {
                $('.js-sidebar-action-header').hide();
                $('.js-sidebar-action-reverse-header').show();
            }
        }
    }
};

// Start Initialization.
Main.init();
